import { render } from "./CrowdsourcingPage.vue?vue&type=template&id=4bbd6b75&scoped=true"
import script from "./CrowdsourcingPage.vue?vue&type=script&lang=js"
export * from "./CrowdsourcingPage.vue?vue&type=script&lang=js"

import "./CrowdsourcingPage.vue?vue&type=style&index=0&id=4bbd6b75&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbd6b75"]])

export default __exports__